import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";

/*
 * @Author: 天吾
 * @Date: 2019-02-19 15:03:49
 * @Last Modified by: lijianzhang
 * @Last Modified time: 2019-11-07 00:35:33
 */
var shorthandMap = {
  'ratios': 'ratios',
  'ch': 'colorHex',
  'colors': 'colors',
  'styles': 'styles',
  'themes': 'themes',
  'pid': 'platform_id',
  'sid': 'scene_id',
  'cid': 'category_id',
  'pn': 'page_num',
  's': 'sort'
};
var blackList = ['__ssr'];
var shorthandKeys = Object.keys(shorthandMap);
var querystringMap = shorthandKeys.reduce(function (obj, key) {
  obj[shorthandMap[key]] = key;
  return obj;
}, {});
var reg = new RegExp('(' + shorthandKeys.map(function (k) {
  return "^" + k + "|-" + k;
}).join('|') + ')', 'g');

function parseQuerystring(querystring) {
  var query = {};
  var arr = querystring.replace(reg, '&$1=').replace(/&-|&/g, ' ').split(' ').filter(function (v) {
    return v;
  });
  arr.forEach(function (q) {
    var key = shorthandKeys.find(function (k) {
      return q.indexOf(k) === 0;
    });
    if (!key) return;
    var value = q.split('=')[1];
    var queryKey = shorthandMap[key];
    if (!queryKey) return;

    if (!query[queryKey] && value !== undefined) {
      query[queryKey] = value;
    } else {
      if (Array.isArray(query[queryKey])) {
        query[queryKey].push(value);
      } else {
        query[queryKey] = [query[queryKey], value];
      }
    }
  });
  return query;
}
/**
 * 修改查询参数的展示方式，但是在使用上没有区别
 * Example： www.gaoding.com/xmtct?filter=9&filter=8 -> www.gaoding.com/xmtct/f9-f8
 * @export
 * @param {*} router
 */


export function seoRouter(router) {
  router.beforeEach(function (to, from, next) {
    var last = to.matched[to.matched.length - 1];

    if (last.path.indexOf(':querystring') > -1 && to.params.querystring) {
      var query = parseQuerystring(to.params.querystring);
      Object.assign(to.query, query);
    }

    next();
  });
  ['push', 'replace', 'resolve'].forEach(function (key) {
    var fn = router[key].bind(router);

    router[key] = function (location, onComplete, onAbort) {
      if (location.query) {
        var route = null;
        var match = router.match(location);

        if (match && match.matched) {
          route = match.matched[match.matched.length - 1];
        }

        if (route && route.path.indexOf(':querystring') > -1) {
          var querystring = undefined;
          var query = {};
          Object.keys(location.query).filter(function (k) {
            return blackList.indexOf(k) === -1;
          }).sort().forEach(function (k) {
            if (querystringMap[k]) {
              if (querystring === undefined) querystring = '';
              if (k === 'page_num' && location.query[k] === 1) return;
              var value = location.query[k];
              value = Array.isArray(value) ? value : [value];
              value = value.filter(function (v) {
                return v;
              });
              value.forEach(function (v) {
                if (querystring) {
                  querystring += '-';
                }

                querystring += "" + querystringMap[k] + v;
              });
            } else {
              query[k] = location.query[k];
            }
          });
          var params = location.params || {};

          if (querystring !== undefined) {
            if (!querystring) {
              delete params.querystring;
            } else {
              params.querystring = querystring;
            }
          }

          return fn(Object.assign({}, location, {
            query,
            params
          }), onComplete, onAbort);
        }
      }

      return fn(location, onComplete, onAbort);
    };
  });
}